import { Routes } from '@angular/router';
import { AsmAuthority } from '@asm/components-core/models/asm-authority';
import { AsmLicensingAuthority } from '@asm/components-core/models/asm-licensing-authority';
import { AsmLicensingAuthorizationTools } from '@asm/components-core/tools/asm-licensing-authorization.tools';
import { AsmRouteId } from '@asm/components-core/models/asm-route-id';
import { AsmRouterTools } from '@asm/components-platform-context/tools/asm-router-tools';

import { environment } from '../environments/environment';

import { RouterTools } from '@sol/components';
import { routesAccount } from './routes/routes-account';
import { routesPlatform } from './routes/routes-platform';
import { routesPartner } from './routes/routes-partner';
import { routesAdmin } from './routes/routes-admin';
import { routesAtp } from './routes/routes-atp';
import { routesEngagementRequests } from './routes/routes-engagement-requests';

export const routes: Routes = [
  ...AsmRouterTools.ofApp(AsmRouteId.app_platform, [...routesPlatform, ...routesAtp, ...routesEngagementRequests]),
  ...AsmRouterTools.ofApp(AsmRouteId.app_partner, routesPartner),
  ...AsmRouterTools.ofApp(AsmRouteId.app_admin, routesAdmin),
  ...(AsmLicensingAuthorizationTools.isAvailable(environment.ASM_LICENSING_URL)
    ? [
        RouterTools.ofExternal(AsmRouteId.app_licensing_external, '{{ASM_LICENSING_URL}}', [
          AsmLicensingAuthority.VIEW_APP,
        ]),
      ]
    : []),
  ...routesAccount,

  // Sol catalog
  RouterTools.ofExternal(AsmRouteId.app_sol_catalog, '{{SOL_CATALOG_URL}}', [AsmAuthority.VIEW_SOL_CATALOG_APP]),

  // ASM Prototype
  RouterTools.ofExternal(AsmRouteId.app_asm_prototype, '{{ASM_PROTOTYPE_URL}}', [AsmAuthority.VIEW_ASM_PROTOTYPE_APP]),

  // Debug
  RouterTools.ofDebug(AsmRouteId.debug),

  // Error
  RouterTools.ofError(AsmRouteId.error),
  {
    path: AsmRouteId.insufficient_auth,
    loadComponent: () =>
      import('@asm/components-platform-context/components/core/asm-insufficient-auth-page/asm-insufficient-auth-page.component').then(
        m => m.AsmInsufficientAuthPageComponent,
      ),
    data: { id: AsmRouteId.insufficient_auth, showNavbar: false },
  },
  {
    path: '**',
    redirectTo: '/error?type=not-found',
  },
];
